var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsAppBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.768a8.851 8.851 0 01-13.108 7.677L0 18l1.595-4.7A8.676 8.676 0 01.327 8.768a8.837 8.837 0 0117.673 0zM9.164 1.4a7.409 7.409 0 00-7.43 7.368A7.294 7.294 0 003.15 13.09l-.928 2.738 2.855-.907a7.437 7.437 0 0011.516-6.152A7.409 7.409 0 009.164 1.4zm4.462 9.391c-.055-.089-.2-.143-.415-.251s-1.282-.628-1.48-.7-.343-.108-.488.107-.559.7-.686.842-.253.162-.469.054a5.929 5.929 0 01-1.742-1.068 6.48 6.48 0 01-1.205-1.488c-.126-.215-.013-.331.1-.438s.217-.251.325-.376a1.441 1.441 0 00.216-.359.392.392 0 00-.018-.377c-.054-.107-.488-1.165-.668-1.6s-.361-.358-.487-.358-.271-.018-.415-.018a.8.8 0 00-.578.269 2.4 2.4 0 00-.758 1.793 4.159 4.159 0 00.884 2.223 8.854 8.854 0 003.7 3.245c2.2.86 2.2.573 2.6.537A2.191 2.191 0 0013.5 11.81a1.792 1.792 0 00.126-1.022z",
    fill: "#5f48e9"
  })));
}

export default SvgWhatsAppBlue;